<template>
  <div class="gp-input-search d-flex align-items-center" :class="[{ focusing: isFocusing }, cClass]">
    <div class="gp-input-search__section">
      <i class="icon icon-small-search gp-input-search-finder"></i>
      <input v-focus="autofocus" ref="search" type="text" :placeholder="placeholder" @mouseover="onHover" @mouseleave="onLeave" @focus="onFocus" @blur="onBlur" @input="onChange" @keyup="onKeyup" v-model="txtValue" autocomplete="new-password" />
      <div class="actions d-flex align-items-center">
        <div class="snack-loading" v-if="indicating"><i class="icon icon-loading text-lightmode"></i></div>
        <i v-if="clear && txtValue && txtValue.length" @click.stop="onClear" class="icon icon-deactivate gp-input-search-clear d-flex align-items-center"></i>
      </div>
    </div>
    <template v-if="hasSelect">
      <slot name="select">
      </slot>
    </template>
  </div>
</template>

<script>
export default {
  name: "GpInputSearch",
  props: {
    value: {
      type: String,
      default: ""
    },
    clear: {
      type: Boolean,
      default: true
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "Search for page ..."
    },
    indicating: {
      type: Boolean,
      default: false
    },
    delayEnter: {
      type: Number,
      default: 200
    },
    hasSelect: Boolean,
    cClass: String
  },
  data() {
    return {
      txtValue: "",
      runner: null,
      runnerValue: null,
      runnerResize: null,
      runnerEnter: null,

      isFocusing: false
    };
  },
  watch: {
    value(value) {
      this.txtValue = value;
    }
  },
  mounted() {
    this.txtValue = this.value;

    window.addEventListener("resize", this.onResize);
  },
  methods: {
    setFocus(position) {
      this.$refs.search.focus();
      this.isFocusing = true;

      if (position) {
        window.setTimeout(() => {
          this.$refs.search.setSelectionRange(position, position);
        }, 0);
      }
    },

    getOffset() {
      if (this.$refs.search) {
        return this.$refs.search.getBoundingClientRect();
      }

      return {};
    },
    onResize() {
      this.runnerResize && clearTimeout(this.runnerResize);

      this.runnerResize = setTimeout(() => {
        if (this.$refs.search) {
          const offset = this.$refs.search.getBoundingClientRect();
          this.$emit("onResize", { offset });
        }
      }, 100);
    },
    onClear() {
      this.$refs.search.focus();
      this.$emit("input", "");
      this.$emit("clear", "");
      this.$emit("onChange", { value: "" });
    },
    onFocus(e) {
      this.$emit("focus", e);
      this.isFocusing = true;
      const offset = this.$refs.search.getBoundingClientRect();
      this.$emit("onFocus", { value: this.txtValue, offset });
    },
    onBlur(e) {
      this.$emit("blur", e);
      this.isFocusing = false;
    },
    onHover() {
      this.runner && clearTimeout(this.runner);

      this.runner = setTimeout(() => {
        const offset = this.$refs.search.getBoundingClientRect();
        this.$emit("onHover", { value: this.txtValue, offset });
      }, 1);
    },
    onLeave() {
      this.runner && clearTimeout(this.runner);

      this.runner = setTimeout(() => {
        const offset = this.$refs.search.getBoundingClientRect();
        this.$emit("onLeave", { value: this.txtValue, offset });
      }, 1);
    },
    onChange() {
      // this.runnerValue && clearTimeout(this.runnerValue);
      this.$emit("input", this.txtValue);
      this.$emit("handleIndicating", this.indicating);
      // this.runnerValue = setTimeout(() => {
      const offset = this.$refs.search.getBoundingClientRect();
      const position = this.$refs.search.selectionStart;
      this.$emit("onChange", { value: this.txtValue, offset, position });
      // }, 500);
    },
    onKeyup(event) {
      this.$emit("keyup", event);
      this.runnerEnter && clearTimeout(this.runnerEnter);

      this.runnerEnter = setTimeout(() => {
        if (event.keyCode === 13) {
          const offset = this.$refs.search.getBoundingClientRect();
          const position = this.$refs.search.selectionStart;
          this.$emit("onEnter", { value: this.txtValue, offset, position });
        }
      }, this.delayEnter);
    }
  }
};
</script>
<style lang="scss">
@keyframes rotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.gp-input-search {
  display: flex;
  align-self: flex-start;
  position: relative;
  width: 100%;
  @include trans-all;
  &__section {
    width: 100%;
    position: relative;
    flex-grow: 1;
  }
  input {
    display: flex;
    // flex: 1;
    padding: 10px 40px;
    line-height: 18px;
    // caret-color: black;
    border-radius: 3px;
    width: 100%;

    &:focus {
      border-color: $mono1;
    }
    &:hover {
      background-color: $light1;
    }

    &::placeholder {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 17px;
    }
  }

  &-finder,
  .actions {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 16px;
  }

  &-finder {
    left: 16px;
    color: $black2 !important;
  }

  .actions {
    right: 0px;
    height: 100%;
    display: flex;
  }

  &-clear {
    // margin-left: 12px;
    padding: 0 16px 0 12px;
    @include trans-all;

    &:hover {
      color: $mono3;
    }
  }

  &.focusing &-finder {
    color: $mono3;
  }
}
.gp-input-indicating {
  right: 42px;
  position: initial !important;
}
.gp-new__search-item {
  box-sizing: border-box !important;
  display: flex;
  align-self: flex-start;
  width: 100%;
  background-color: #FFFFFF;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 40px;
  @include trans-all;
  &__section {
    width: 100%;
    position: relative;
    flex-grow: 1;
  }
  &:hover {
      border-color: $black3;
      // background-color: transparent !important;
  }
  input {
    display: flex;
    padding: 12px 70px 12px 40px;
    line-height: 18px;
    border-radius: $radius;
    border: none;
    box-sizing: border-box !important;
    background: transparent !important;
    width: 100%;
    font-size: 14px;
    line-height: 16px;
    color: $textLightModeHigh;
    @include trans-all;
    // &:focus {
    //   border-color: $mono1;
    // }
    &::placeholder {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: $textLightModeDisabled;
    }
  }
  .gp-input-search__section {
    width: 100%;
    position: relative;
    flex-grow: 1;
  }
  .gp-input-search-finder,
  .actions {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 16px;
  }
  .gp-input-search-finder {
    left: 16px;
  }
  .actions {
    right: 0px;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .gp-input-search-clear {
    margin-left: 12px;
    padding: 0 16px 0 0;
    @include trans-all;
    &:hover {
      color: black !important;
    }
  }
  &.focusing {
    border: 1px solid $mono3;
    border-radius: 3px;
    background: #FFFFFF;
  }
}
.snack-loading {
  width: 24px;
  height: 24px;
  animation: cog 1s infinite;
  display: flex;
  align-items: center;
  justify-content: center;
}
@keyframes cog {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.assign-product__search-item {
  box-sizing: border-box !important;
  display: flex;
  align-self: flex-start;
  width: 100%;
  background-color: #FFFFFF;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 40px;
  @include trans-all;
  &__section {
    position: relative;
    flex-grow: 1;
  }
  &:hover {
      border-color: $black3;
      // background-color: transparent !important;
  }
  input {
    display: flex;
    padding: 12px 70px 12px 40px;
    line-height: 18px;
    border-radius: $radius;
    border: none;
    box-sizing: border-box !important;
    background: transparent !important;
    width: 100%;
    font-size: 14px;
    line-height: 16px;
    color: $textLightModeHigh;
    @include trans-all;
    // &:focus {
    //   border-color: $mono1;
    // }
    &::placeholder {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: $textLightModeDisabled;
    }
  }
  .gp-input-search-finder,
  .actions {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 16px;
  }
  .gp-input-search-finder {
    left: 16px;
  }
  .actions {
    right: 0px;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .gp-input-search-clear {
    margin-left: 12px;
    padding: 0 16px 0 0;
    @include trans-all;
    &:hover {
      color: black !important;
    }
  }
  &.focusing {
    border: 1px solid $mono3;
    border-radius: 3px;
    background: #FFFFFF;
  }
}
</style>
